import React,{useState} from 'react';
import {CallApi} from "../common/API/APi";

import {success,error} from "../common/Toastify"; 

const ManualPayment = (props) => {
  const [transcationids, settranscationids] = useState();
  const [amount, setamount] = useState();
  const {manualpayid,setManualpayid,setNotifyrole}=props;
   console.log(manualpayid,"manualpayidmanualpayid");
   const updatetranscation=async()=>{
    if(!transcationids){
         error("Transcation id is required!");
         return;
    }
    let regex = /^\d*\.?\d*$/;
    
    if(!amount || !regex.test(amount)){
      error("Amount is invalid!");
      return;
    }
    success("Please wait a sec....");
           let res = await CallApi({"order_id":manualpayid,"transcation_id":transcationids,'amount':amount}, 'manual-payment');
           if(res?.status === 200){
              success(res?.message);
              settranscationids('');
              setManualpayid('');
              setamount('');
              setNotifyrole(current => !current);
             document.querySelector(".manualpaycancel").click();
           } else{
            error('Something went wrong');
           }
    }

  return(
    <div className="modal fade com-modal" id="manualpaymentModel" tabIndex="-1" aria-labelledby="manualpaymentModelLabel" aria-hidden="true">
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h1 className="modal-title fs-5 golden-text" id="manualpaymentModelLabel">Manual Payment</h1>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div className="modal-body pb-0">
       
          <div className='row'>
         
            <div className='col-md-12 mb-4 '>
              <label className="mb-1 d-block">Transcation ID</label>
              <input type="text" value={transcationids} onChange={(e)=>settranscationids(e.target.value)} className='com-input-field '/>
            </div>
              
            <div className='col-md-12 mb-4 '>
              <label className="mb-1 d-block">Amount</label>
              <input type="text" value={amount} onChange={(e)=>setamount(e.target.value)} className='com-input-field '/>
            </div>

          </div>
 
        </div>
        <div className="modal-footer text-center">
          <button type="button" className="golden-bg font-13px com-btn golden-border" onClick={updatetranscation} >Update</button>
          <button type="button" className="golden-bg font-13px com-btn com-btn-outline golden-border bg-transparent manualpaycancel" data-bs-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
    </div>
  )
}
export default ManualPayment;